import { Shield, ShieldCheck, UserCheck, Users } from "lucide-react";
import { StatCard } from "@/components/shared/StatCard";
import type { PaginationMeta } from "@/types/common";
import type { User } from "@/types/user";
import { UserResponseDtoRole } from "@/types/api";

interface UsersStatsProps {
  users: User[];
  meta: PaginationMeta | undefined;
}

export function UsersStats({ users, meta }: UsersStatsProps) {
  const total = meta?.total ?? 0;
  const active = users.filter((u) => u.isActive).length;
  const superAdmins = users.filter(
    (u) => u.role === UserResponseDtoRole.SUPER_ADMIN,
  ).length;
  const subAdmins = users.filter(
    (u) => u.role === UserResponseDtoRole.SUB_ADMIN,
  ).length;
  const editors = users.filter(
    (u) => u.role === UserResponseDtoRole.EDITOR,
  ).length;

  return (
    <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <StatCard
        label="إجمالي المستخدمين"
        value={total}
        sub="إجمالي المستخدمين المطابقين"
        icon={Users}
        accent="primary"
      />
      <StatCard
        label="النشطون"
        value={active}
        sub="مستخدمون نشطون في الصفحة الحالية"
        icon={UserCheck}
        accent="accent"
      />
      <StatCard
        label="المدراء"
        value={superAdmins + subAdmins}
        sub={`مدير عام: ${superAdmins} · مدير فرعي: ${subAdmins}`}
        icon={ShieldCheck}
        accent="secondary"
      />
      <StatCard
        label="المحررون"
        value={editors}
        sub="محررون في الصفحة الحالية"
        icon={Shield}
        accent="muted"
      />
    </div>
  );
}
